export default __webpack_public_path__ + "static/media/logo256.56d47c40.png";